const EmployeeTypes = Object.freeze({
  'GERENTE': {text: 'Gerente',
    idType: 'id'},
  'GERENTEUSER': {text: 'Gerente',
    idType: 'usuarioId'},
  'RESPONSAVEL': {text: 'Responsável pela Carteira',
    idType: 'usuarioId'},
  'RESPONSAVELVISITA': {text: 'Responsável Visita',
    idType: 'usuarioId'},
  'RESPONSAVELCARD': {text: 'Responsável Card',
    idType: 'usuarioId'},
  'USERALT': {text: 'Usuário Alteração',
    idType: 'usuarioId'}
})

export default EmployeeTypes



// WEBPACK FOOTER //
// ./src/enums/enumEmployeeTypes.js